import {Component, OnInit, ViewChild} from '@angular/core';
import {InformationsService} from '../../services/informations.service';
import {Information} from '../../model/information';
import {DomSanitizer} from '@angular/platform-browser';
import {AdminPageModelComponent} from "../../components/admin/admin-page-model/admin-page-model.component";
import {SearchBarComponent} from "../../components/common/search-bar/search-bar.component";
import {InfoBlockComponent} from "../../components/common/info-block/info-block.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

import {InfoTypePipe} from "../../components/common/InfoTypePipe";
import {SearchPipe} from "../../components/common/SearchPipe";
import {DynamicModalFormComponent} from "../../components/common/dynamic-modal-form/dynamic-modal-form.component";
import {SpinnerComponent} from "../../components/common/spinner/spinner.component";

@Component({
    selector: 'app-infos-archive',
    templateUrl: './infos-archive.component.html',
    imports: [
    AdminPageModelComponent,
    SpinnerComponent,
    InfoTypePipe,
    SearchBarComponent,
    InfoBlockComponent,
    SearchPipe,
    DynamicModalFormComponent,
    FaIconComponent
],
    styleUrls: ['./infos-archive.component.css']
})
export class InfosArchiveComponent implements OnInit {
  infos: Information[];
  archived: Information[];

  encodedInfos: any;
  toPurge: any;

  search = '';

  @ViewChild('dynamicdownload') dynamicdownload: HTMLElement;

  constructor(private infosService: InformationsService, private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.infosService.getObjects().subscribe(infos => {
      this.infos = infos;
      this.archived = [];
      infos.forEach(info => {
        if (info.type === 'ARCHIVED') {
          this.archived.push(info);
        }
      });
      this.encodedInfos = this.sanitizer.bypassSecurityTrustUrl('data:text/json;charset=UTF-8,' +
        encodeURIComponent(JSON.stringify(this.archived)));
    });
  }

  purgeArchives(): void {
    this.infosService.purgeArchive();
  }

}
